var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8798)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8798)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8798)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8020_8798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H5V19H19V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8020_8798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.622 5.37844C18.4497 5.20455 18.2312 5.08386 17.9922 5.03071C17.7534 4.97757 17.5042 4.9942 17.2745 5.07861L17.1485 5.12352C14.3343 6.03364 11.772 7.58968 9.66667 9.66711C8.60961 10.8517 7.68987 12.152 6.925 13.5433L8.2585 14.9171L6.75 16.4256L7.57483 17.2504L9.08333 15.7419L10.4367 17.0952C11.8276 16.3301 13.1278 15.4104 14.3123 14.3536C16.3967 12.2408 17.96 9.67131 18.8781 6.84902L18.9218 6.72594C19.0062 6.49622 19.0229 6.24708 18.9697 6.00815C18.9165 5.76927 18.7958 5.5507 18.622 5.37844ZM11.4167 13.1671C11.3013 13.1671 11.1885 13.1328 11.0926 13.0687C10.9967 13.0047 10.9219 12.9135 10.8777 12.807C10.8336 12.7003 10.822 12.5831 10.8445 12.4699C10.867 12.3568 10.9226 12.2528 11.0042 12.1713C11.0857 12.0896 11.1897 12.0341 11.3029 12.0116C11.416 11.9891 11.5333 12.0006 11.6399 12.0448C11.7465 12.0889 11.8376 12.1637 11.9017 12.2596C11.9658 12.3556 12 12.4683 12 12.5837C12 12.7384 11.9385 12.8868 11.8291 12.9962C11.7198 13.1056 11.5714 13.1671 11.4167 13.1671ZM13.1667 11.4171C13.0513 11.4171 12.9385 11.3828 12.8426 11.3187C12.7467 11.2547 12.6719 11.1635 12.6277 11.057C12.5836 10.9503 12.572 10.8331 12.5945 10.7199C12.617 10.6068 12.6726 10.5028 12.7542 10.4213C12.8357 10.3396 12.9397 10.2841 13.0529 10.2616C13.166 10.2391 13.2833 10.2506 13.3899 10.2948C13.4965 10.3389 13.5876 10.4137 13.6517 10.5096C13.7158 10.6056 13.75 10.7183 13.75 10.8337C13.75 10.9884 13.6885 11.1368 13.5791 11.2462C13.4698 11.3556 13.3214 11.4171 13.1667 11.4171ZM14.9167 9.66711C14.8013 9.66711 14.6885 9.63286 14.5926 9.56876C14.4967 9.50471 14.4219 9.41359 14.3777 9.30701C14.3336 9.20038 14.322 9.08313 14.3445 8.96996C14.367 8.8568 14.4226 8.75285 14.5042 8.6713C14.5857 8.58969 14.6897 8.53416 14.8029 8.51164C14.916 8.48912 15.0333 8.50067 15.1399 8.54483C15.2465 8.58899 15.3376 8.66377 15.4017 8.75967C15.4658 8.85563 15.5 8.96839 15.5 9.08377C15.5 9.23847 15.4385 9.38681 15.3291 9.49625C15.2198 9.60562 15.0714 9.66711 14.9167 9.66711ZM16.0524 14.1949C15.9792 15.137 15.7064 16.0528 15.252 16.8813C14.7975 17.7099 14.172 18.4322 13.4169 19.0004H11.4167V17.8792C12.7549 17.1224 14.0032 16.2166 15.1377 15.179C15.4592 14.8587 15.7607 14.5286 16.0524 14.1949ZM8.82142 8.83177C7.78378 9.96624 6.87798 11.2145 6.12117 12.5528H5V10.5526C5.56817 9.79748 6.29051 9.17197 7.11907 8.71756C7.94758 8.26314 8.86336 7.99026 9.8055 7.91711C9.47183 8.20877 9.14167 8.51036 8.82142 8.83177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26126 14.9137L6.6792 16.4958L7.50415 17.3207L9.08621 15.7386L8.26126 14.9137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1196 4.87781L17.9946 6.90367L17.0938 6.00288L19.1196 4.87781Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8798",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/Action.8ffba46ac94628bf8af906fbf0ad6d52.svg";
export { ForwardRef as ReactComponent };